var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("neu-cards-slider-pricing", {
        staticClass: "section py-lg-5 py-0",
        attrs: {
          cards: _vm.cardProfessional,
          iva: _vm.$t("iva-not-included"),
          cards2: _vm.cardLawFirm,
          title: _vm.$t("abogalitypro.subscriptions.title")
        },
        scopedSlots: _vm._u([
          {
            key: "conditions",
            fn: function() {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("abogalitypro.subscriptions.law-firm-text"))
                  )
                ]),
                _c("br"),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("abogalitypro.subscriptions.price-text"))
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7803452", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7803452","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/abogalitypro/AbogalitySubscriptions.vue
// module id = 4261
// module chunks = 10